import { defineMessages } from "react-intl";

export const contactHelpMessages = defineMessages({
  title: {
    id: "contact-help.title",
    defaultMessage: "Помощь",
  },
});
